export * from './baFullCalendar.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baFullCalendar/index.ts